/* eslint-disable no-nested-ternary,@typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerFacebookAdsInsightsSourceComponent', [
    'DesignerBaseSourceAndDestinationComponent',

    function (DesignerBaseSourceAndDestinationComponent) {
      function DesignerFacebookAdsInsightsSourceComponent() {
        DesignerBaseSourceAndDestinationComponent.apply(this);

        this.api_version = null;
        this.ad_accounts = null;
        this.level = null;
        this.action_report_time = null;
        this.time_increment = null;
        this.report_date_range_type = null;
        this.report_date_range_min = null;
        this.report_date_range_max = null;
      }

      DesignerFacebookAdsInsightsSourceComponent.prototype = new DesignerBaseSourceAndDestinationComponent();

      DesignerFacebookAdsInsightsSourceComponent.prototype.getData = function () {
        const data = DesignerBaseSourceAndDestinationComponent.prototype.getData.call(this);

        _.extend(data, {
          with_custom_fields:
            angular.isDefined(this.api_version) && angular.isUndefined(this.with_custom_fields)
              ? true
              : this.with_custom_fields
              ? this.with_custom_fields
              : this.defaults.with_custom_fields,
          api_version: this.api_version || this.defaults.api_version,
          ad_accounts: this.ad_accounts || this.defaults.ad_accounts,
          level: this.level || this.defaults.level,
          action_report_time: this.action_report_time || this.defaults.action_report_time,
          time_increment: this.time_increment || this.defaults.time_increment,
          filtering: this.filtering || this.defaults.filtering,
          report_date_range_type: this.report_date_range_type || this.defaults.report_date_range_type,
          report_date_range_min: this.report_date_range_min || this.defaults.report_date_range_min,
          report_date_range_max: this.report_date_range_max || this.defaults.report_date_range_max,
          manual_breakdown: this.manual_breakdown || this.defaults.manual_breakdown,
          report_on: this.report_on || this.defaults.report_on,
          cloud_storage_connection_id: String(this.connection.id || ''),
        });

        return data;
      };

      DesignerFacebookAdsInsightsSourceComponent.prototype.setFormData = function (data) {
        this.setData(data);

        DesignerBaseSourceAndDestinationComponent.prototype.setFormData.call(this, data);
      };

      DesignerFacebookAdsInsightsSourceComponent.prototype.setData = function (data) {
        this.cloud_storage_connection_id = String(this.connection.id || '');
        this.api_version = data.api_version;
        this.level = data.level;
        this.action_report_time = data.action_report_time;
        this.time_increment = data.time_increment;
        this.filtering = data.filtering;
        this.report_date_range_type = data.report_date_range_type;

        if (data.report_date_range_type === 'CUSTOM_DATE') {
          this.report_date_range_min = data.report_date_range_min;
          this.report_date_range_max = data.report_date_range_max;
          this.manual_breakdown = data.manual_breakdown;
        } else {
          this.report_date_range_min = '';
          this.report_date_range_max = '';
          this.manual_breakdown = 'Default';
        }

        if (data.all_accounts || data.report_on === 'all' || !data.ad_accounts || data.ad_accounts[0] === 'any')
          this.report_on = 'all';
        else this.report_on = 'specific';

        if (this.report_on === 'all') this.ad_accounts = ['any'];
        else this.ad_accounts = data.ad_accounts;

        this.with_custom_fields = data.with_custom_fields;

        DesignerBaseSourceAndDestinationComponent.prototype.setData.call(this, data);
      };

      DesignerFacebookAdsInsightsSourceComponent.prototype.getSchema = function () {
        const schema = DesignerBaseSourceAndDestinationComponent.prototype.getSchema.call(this);

        return schema;
      };

      return DesignerFacebookAdsInsightsSourceComponent;
    },
  ]);
})(window.angular);
